// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sendForm_wrapper__3Qr35","icon":"sendForm_icon__3uqjK","file":"sendForm_file__eDYA_","buttonContainer":"sendForm_buttonContainer__2vgTi"};